import React from "react";
import PropTypes from "prop-types";

import CustomSelect from "./CustomSelect";
import CustomInput from "./CustomInput";
import CustomBoolean from "./CustomBoolean";

const customFieldComponents = {
  select: CustomSelect,
  input: CustomInput,
  boolean: CustomBoolean,
};

class CustomFields extends React.Component {
  checkStepNumber(number) {
    const { checkStepNumber } = this.props;

    return checkStepNumber(number);
  }

  render() {
    const { customFields = [], wrapperClassName = "row", isEmbedded } = this.props;

    const fields = customFields.reduce((array, customField) => {
      const htmlType = customField.get("html_control");
      const stepNumber = customField.get("display_on_step") || 0;

      if (this.checkStepNumber(stepNumber)) {
        const CustomFieldComponent = customFieldComponents[htmlType];

        const wrapperClassName = isEmbedded
          ? "width-99-mobile padding-0 col-xs-12 col-sm-6"
          : "col-xs-12 col-sm-6";

        array.push(
          <CustomFieldComponent
            key={customField.get("name")}
            wrapperClassName={wrapperClassName}
            customField={customField}
            isEmbedded={isEmbedded}
          />,
        );
      }
      return array;
    }, []);

    return <div className={wrapperClassName}>{fields}</div>;
  }
}

CustomFields.propTypes = {
  checkStepNumber: PropTypes.func.isRequired,
  customFields: PropTypes.object.isRequired,
  wrapperClassName: PropTypes.string,
};

export default CustomFields;
